/**
 * @ Author: DY
 * @ Date: 2023-11-02 12:00:18
 * @ LastEditTime: 2023-11-02 12:00:35
 * @ Description: 消息跳转办理页面，根据消息中租户id获取指定租户token
 * @ FilePath: \ShiMo_Mobile\src\assets\mixin\mixin_MessageJump.js
 */
export const mixin_MessageJump = {
    data() {
        return {
            // 取当前消息租户token
            newsToken: '',
        };
    },
    created() { },
    methods: {
        async getNewsToken(tenant_id) {
            const currentTenantID = this.$takeTokenParameters('TenantId');
            if (tenant_id !== currentTenantID) {
                const res = await this.getTenantToken(tenant_id);
                this.newsToken = `${res.token_type} ${res.access_token}`;
            } else {
                this.newsToken = '';
            }
        },

        // 多租户消息打开办理页面，取token
        getTenantToken(TenantId) {
            const qs = require('qs');
            let token = this.token = window.localStorage.getItem('token');
            token = token.split(' ')[1];
            return this.$axios.$post('/interfaceApi/login/switch_tenant', qs.stringify({
                token: token,
                tenantId: TenantId,
            }), {
                options: {
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        contenttype: 'application/x-www-form-urlencoded',
                    },
                },
            });
        },
    },
};